import React from 'react';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { DotLoader } from '@lifeomic/chroma-react/components/DotLoader';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export type LoadingDisplayOwnProps = {};

export type LoadingDisplayProps = LoadingDisplayOwnProps;

const LoadingDisplay: React.FC<LoadingDisplayProps> = () => {
  const classes = useStyles({});

  return (
    <div className={classes.root}>
      <DotLoader size={0} />
    </div>
  );
};

export default React.memo(LoadingDisplay);
